export const initClinicBranchesRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/clinic-branches",
          name: "clinic-branches",
          component: () =>
            import("@/pages/manage/clinic-branches/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
      ];
